<body>
  <div class="container">
    <section id="signInput">
      <div class="row">
        <div class="col-lg-8 text-right grid-elements">
          <h3 class="text-center py-3">انضم الان لأكبر منصة تجارة الكترونية</h3>
          <div class="row justify-content-end grid-element">
            <div class="col-md-6">
              <div class="media my-2">
                <img
                  width="10%"
                  class="mr-3 mt-3 ml-4 pt-2"
                  src="https://image.flaticon.com/icons/png/512/732/732200.png"
                />
                <div class="media-body p-1">
                  <p class="text-muted pr-3 pt-1">الايميل الشخصي</p>
                  <input type="email" class="form-control" />
                </div>
              </div>
              <div class="media my-2">
                <img
                  width="10%"
                  class="mr-3 mt-3 ml-4 pt-2"
                  src="https://image.flaticon.com/icons/png/512/273/273177.png"
                />
                <div class="media-body p-1">
                  <p class="text-muted pr-3 pt-1">اسم المتجر</p>
                  <input type="email" class="form-control" />
                </div>
              </div>

              <div class="media my-2">
                <img
                  width="10%"
                  class="mr-3 mt-3 ml-4 pt-2"
                  src="https://t3.ftcdn.net/jpg/02/96/91/42/240_F_296914204_8F0EmCJh8nVo7c0MYJtwUdEqnG1xs6Bq.jpg"
                />
                <div class="media-body p-1">
                  <p class="text-muted pr-3 pt-1">كيان المتجر</p>
                  <input type="email" class="form-control" />
                </div>
              </div>

              <div class="media my-2">
                <img
                  width="10%"
                  class="mr-3 mt-3 ml-4 pt-2"
                  src="https://www.flaticon.com/premium-icon/icons/svg/2549/2549951.svg"
                />
                <div class="media-body p-1">
                  <p class="text-muted pr-3 pt-1">تأكيد كلمة المرور</p>
                  <input type="email" class="form-control" />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="media my-2">
                <img
                  width="10%"
                  class="mr-3 mt-3 ml-4 pt-2"
                  src="https://image.flaticon.com/icons/png/512/456/456212.png"
                />
                <div class="media-body p-1">
                  <p class="text-muted pr-3 pt-1">الأسم كاملا</p>
                  <input type="email" class="form-control" />
                </div>
              </div>
              <div class="media my-2">
                <img
                  width="10%"
                  class="mr-3 mt-3 ml-4 pt-2"
                  src="https://image.flaticon.com/icons/png/512/483/483947.png"
                />
                <div class="media-body p-1">
                  <p class="text-muted pr-3 pt-1">رقم الجوال</p>
                  <input type="email" class="form-control" />
                </div>
              </div>

              <div class="media my-2">
                <img
                  width="10%"
                  class="mr-3 mt-3 ml-4 pt-2"
                  src="https://www.flaticon.com/premium-icon/icons/svg/2985/2985013.svg"
                />
                <div class="media-body p-1">
                  <p class="text-muted pr-3 pt-1">رابط المتجر</p>
                  <input type="email" class="form-control" />
                </div>
              </div>

              <div class="media my-2">
                <img
                  width="10%"
                  class="mr-3 mt-3 ml-4 pt-2"
                  src="https://www.flaticon.com/premium-icon/icons/svg/2549/2549951.svg"
                />
                <div class="media-body p-1">
                  <p class="text-muted pr-3 pt-1">كلمة المرور</p>
                  <input type="email" class="form-control" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 align-self-center mt-5 img-signUp" height="600">
          <img
            width="100%"
            src="https://images.pexels.com/photos/4050470/pexels-photo-4050470.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            alt=""
          />
        </div>

        <div class="d-flex align-items-end text-right"></div>
      </div>
      <div id="flex-box" class="row">
        <div class="col-md-7">
          <div class="d-flex justify-content-end row-hl">
            <div class="p-4 item-hl text-right">
              <span class="flex-1">
                بالتسجيل فأنا أوافق على
                <a routerLink="/theUse">اتفاقية الاستخدام</a> و<a
                  routerLink="/privecy"
                  >سياسة الخصوصية</a
                >
              </span>
              <input class="flex-2" type="checkbox" class="" />
            </div>
          </div>

          <div class="d-flex justify-content-between row-hl ml-5">
            <div class="item-h1">
              <p class="btn text-left">
                <a class="text-dark" routerLink="">تسجيل جديد </a>
                <span
                  ><img
                    width="15%"
                    src="https://t3.ftcdn.net/jpg/03/08/40/24/240_F_308402417_GqkJdF2DQE05p84aWzYKbbMn0IKbhQFn.jpg"
                    alt=""
                /></span>
              </p>
            </div>

            <div class="item-h1 pt-2">
              <p class="text-muted text-right">
                لديك حساب بالفعل؟
                <span>
                  <a routerLink=""
                    ><strong class="text-dark">تسجيل الدخول</strong></a
                  >
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section></section>
  </div>
</body>
